import type { VideoCommentaryProps } from '../templates/custom/video-commentary';

export const videoCommentaryDatasets: Record<string, VideoCommentaryProps> = {
  /**
   * 多段解说 + 低原声音量：有小鸭子的视频
   */
  multiSegment: {
    backgroundVideo: {
      url: 'https://p26-bot-workflow-sign.byteimg.com/tos-cn-i-mdko3gqilj/5d7be91d76b84e09a6bf224cdc645af5.mp4~tplv-mdko3gqilj-image.image?rk3s=81d4c505&x-expires=1805443482&x-signature=rGVYD8dm06BfqfDClL5AONeIDUE%3D&x-wf-file_name=bc8c2723-1f1d-48a3-849c-93686d8c016e.mp4',
    },
    comments: [
      {
        startTime: 0,
        endTime: 10,
        audioUrl:
          'https://p26-bot-workflow-sign.byteimg.com/tos-cn-i-mdko3gqilj/bc11512776dd46d68ec1469e4086351a.mp3~tplv-mdko3gqilj-image.image?rk3s=81d4c505&x-expires=1805443456&x-signature=nU3K8UMfhcbzLpKEhHyMVgyUn9I%3D&x-wf-file_name=MiniMax_1.mp3',
      },
      {
        startTime: 10,
        endTime: 25,
        audioUrl:
          'https://p9-bot-workflow-sign.byteimg.com/tos-cn-i-mdko3gqilj/f0537a616084494795534b8fdd60702d.mp3~tplv-mdko3gqilj-image.image?rk3s=81d4c505&x-expires=1805443464&x-signature=Ypf%2F9UZ7u%2FEcAxqqSTARczF5xI0%3D&x-wf-file_name=MiniMax_2.mp3',
      },
      {
        startTime: 25,
        endTime: 46,
        audioUrl:
          'https://p9-bot-workflow-sign.byteimg.com/tos-cn-i-mdko3gqilj/13c477fbd6e143fe855a91aac39e03e7.mp3~tplv-mdko3gqilj-image.image?rk3s=81d4c505&x-expires=1805443467&x-signature=Q7EbQYPQMlM4rSkvGEZyHUoYMNg%3D&x-wf-file_name=MiniMax_3.mp3',
      },
      {
        startTime: 46,
        endTime: 61,
        audioUrl:
          'https://p26-bot-workflow-sign.byteimg.com/tos-cn-i-mdko3gqilj/ff15451b2d9a4d1ab961c71046bd6cdf.mp3~tplv-mdko3gqilj-image.image?rk3s=81d4c505&x-expires=1805443469&x-signature=hRl%2FxcOS2dR%2FICQp0i0Q9d6PeTc%3D&x-wf-file_name=MiniMax_4.mp3',
      },
    ],
    voiceVolume: 100,
    originalVolume: 10,
    fastForwardSpeed: 2,
  },

  /**
   * 单段解说 — 使用公共示例素材
   */
  singleSegment: {
    backgroundVideo: {
      url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    },
    comments: [
      {
        startTime: 0,
        endTime: 10,
        audioUrl:
          'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
      },
    ],
    voiceVolume: 100,
    originalVolume: 100,
  },

  /**
   * 六段解说 + 保留原声：Bug素材 -> 当视频长度大于音频长度，现在会一直播，不会像之前那样跳过，大结尾3分12秒后面都是一直播放的
   */
  sixSegment: {
    backgroundVideo: {
      url: 'https://chatcut.framefuture.cn/demo/25c06210214c4691b07fe52ba5e2d308.mp4~tplv-mdko3gqilj-image.mp4',
      duration: null,
    },
    comments: [
      {
        startTime: 0,
        endTime: 11,
        audioUrl:
          'https://chatcut.framefuture.cn/demo/526e5da40dc844d8aa78a076d9cc33f8.mp3~tplv-mdko3gqilj-image.mp3',
      },
      {
        startTime: 11,
        endTime: 26,
        audioUrl:
          'https://chatcut.framefuture.cn/demo/922d4d3b72884cbca16a73f35498eeb2.mp3~tplv-mdko3gqilj-image.mp3',
      },
      {
        startTime: 26,
        endTime: 53,
        audioUrl:
          'https://chatcut.framefuture.cn/demo/5cc8232a494e499ea162c03b9b6833c2.mp3~tplv-mdko3gqilj-image.mp3',
      },
      {
        startTime: 53,
        endTime: 62,
        audioUrl:
          'https://chatcut.framefuture.cn/demo/c6e5c64ec41643ca8f440edb0d2e67f0.mp3~tplv-mdko3gqilj-image.mp3',
      },
    ],
    voiceVolume: 100,
    originalVolume: 1,
  },

  /**
   * Bug素材：视频第3秒停止的时候，会跳到第4秒，然后又跳回第3秒
   */
  jumpBugSegment: {
    backgroundVideo: {
      url: 'https://framefuture-video.oss-cn-beijing.aliyuncs.com/uploads/1959922234266685440/1774952894750-16linc8r-v0-1773744065791-1218-0.mp4?Expires=1775212099&OSSAccessKeyId=LTAI5tChKsAFev3Lwhjd5ng7&Signature=lPMr363buBZz6DdzHkLxJw4Si%2F0%3D',
    },
    comments: [
      {
        startTime: 0,
        endTime: 3,
        audioUrl:
          'https://minimax-algeng-chat-tts.oss-cn-wulanchabu.aliyuncs.com/audio%2Feffect%2F061ad50e7cab1f92d3800c3d15a1d485_1774952977617_2618.mp3?Expires=1775039377&OSSAccessKeyId=LTAI5tGLnRTkBjLuYPjNcKQ8&Signature=dXQ88OwuRblUevNcg2QqRKXt0JM%3D',
      },
      {
        startTime: 3,
        endTime: 8,
        audioUrl:
          'https://minimax-algeng-chat-tts.oss-cn-wulanchabu.aliyuncs.com/audio%2Feffect%2F061ad50ef43b808582301167ce340baf_1774952977223_6917.mp3?Expires=1775039377&OSSAccessKeyId=LTAI5tGLnRTkBjLuYPjNcKQ8&Signature=G1KqaqNgiDJcFEbeUkx8oGFsuHc%3D',
      },
      {
        startTime: 8,
        endTime: 14,
        audioUrl:
          'https://minimax-algeng-chat-tts.oss-cn-wulanchabu.aliyuncs.com/audio%2Feffect%2F061ad50e5e1e158242a2147e05e951c8_1774952977469_3727.mp3?Expires=1775039377&OSSAccessKeyId=LTAI5tGLnRTkBjLuYPjNcKQ8&Signature=mAaimsgca9wMwtkN3fyHRwDmV%2BY%3D',
      },
      {
        startTime: 14,
        endTime: 17,
        audioUrl:
          'https://minimax-algeng-chat-tts.oss-cn-wulanchabu.aliyuncs.com/audio%2Feffect%2F061ad50e22a0c3f347ab2a4b8cfee8ab_1774952976753_1780.mp3?Expires=1775039376&OSSAccessKeyId=LTAI5tGLnRTkBjLuYPjNcKQ8&Signature=L%2BJ1qExqPfLTRTwtLBbElkGWTqw%3D',
      },
      {
        startTime: 17,
        endTime: 23,
        audioUrl:
          'https://minimax-algeng-chat-tts.oss-cn-wulanchabu.aliyuncs.com/audio%2Feffect%2F061ad50eff70eacb40d32aa939cd6bc8_1774952977017_8439.mp3?Expires=1775039377&OSSAccessKeyId=LTAI5tGLnRTkBjLuYPjNcKQ8&Signature=HLfADGINbyySEz73c5woKaQtXYc%3D',
      },
      {
        startTime: 23,
        endTime: 30,
        audioUrl:
          'https://minimax-algeng-chat-tts.oss-cn-wulanchabu.aliyuncs.com/audio%2Feffect%2F061ad50e96091ba4042dcc59458b0c1b_1774952977195_8494.mp3?Expires=1775039377&OSSAccessKeyId=LTAI5tGLnRTkBjLuYPjNcKQ8&Signature=%2FLD5Z6cx1EMpEKqTNOsLF%2FNs2TM%3D',
      },
      {
        startTime: 30,
        endTime: 38,
        audioUrl:
          'https://minimax-algeng-chat-tts.oss-cn-wulanchabu.aliyuncs.com/audio%2Feffect%2F061ad50ea2b0ef0f1871c3446bc72339_1774952977399_2800.mp3?Expires=1775039377&OSSAccessKeyId=LTAI5tGLnRTkBjLuYPjNcKQ8&Signature=EdgcukNx2dXgyHOSISX6KdBv5qY%3D',
      },
    ],
    voiceVolume: 100,
    originalVolume: 1,
  },
};

/**
 * 切换此处的 key 即可更换测试数据：'multiSegment' | 'singleSegment' | 'sixSegment' | 'jumpBugSegment'
 */
export const ACTIVE_DATASET: keyof typeof videoCommentaryDatasets = 'jumpBugSegment';

export const defaultVideoCommentaryProps: VideoCommentaryProps =
  videoCommentaryDatasets[ACTIVE_DATASET];
